<template>
    <div>
        Dashboard
    </div>
</template>

<script>
    export default {
        name: 'dashboard',
        data: () => ({

        }),
    }
</script>

<style lang="scss" scoped>

</style>